import { Header } from '@pentabd/ui';
import { useTranslation } from 'react-i18next';

type ConstituencyWiseResultsHeaderProps = {
  setParams: (params: { election_schedule_id: string }) => void;
  searchParams: URLSearchParams;
  handleQuery: (name: string, value: string | number) => void;
};

export function ConstituencyWiseResultsHeader({
  setParams,
  searchParams,
  handleQuery,
}: ConstituencyWiseResultsHeaderProps) {
  const { t } = useTranslation();

  const headerText = {
    header: t('CONSTITUENCY_WISE_RESULTS.HEADER.TEXT'),
  };

  return (
    <div className="mt-20">
      <Header headerText={headerText} />
    </div>
  );
}
